const StaffDirectory = () => {
  return (
    <div>
      <p>Annuaire staff page</p>
    </div>
  );
};

export default StaffDirectory;
